
export default {
  props: {
    isNegative: {
      type: Boolean,
      default: false,
    },
  },
}
